import PropTypes from 'prop-types';

export default PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number,
    search: PropTypes.string,
    text: PropTypes.string,
  })
);
